import React from "react";
import { WHATSAPP_GROUP, GROUP_MEMBERS, groupClients } from "../mock";
import { MessageCircle, Users, Gift, Bell } from "lucide-react";

export default function WhatsAppGroup() {
  const perks = [
    { icon: Gift, title: "Exclusive drops", desc: "Members-only launches & discounts." },
    { icon: Bell, title: "Early access", desc: "Be the first to know about new products." },
    { icon: Users, title: "Real community", desc: "Tips, routines & hair care support." },
  ];

  return (
    <section id="whatsapp-group" className="section scroll-mt-24 bg-[#1a1a1a] text-[#FBF8F4] relative overflow-hidden" data-testid="whatsapp-group-section">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #C9A961 0%, transparent 40%), radial-gradient(circle at 80% 70%, #C9A961 0%, transparent 45%)",
        }}
      />
      <div className="container-y relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="font-sans-y text-[11px] tracking-[0.35em] uppercase text-[#C9A961] mb-4">
              Free community
            </p>
            <h2 className="font-serif-y text-4xl md:text-6xl leading-[1.05] mb-6">
              Join our WhatsApp <span className="italic text-[#C9A961]">Group</span>
            </h2>
            <p className="font-sans-y text-[15px] md:text-base leading-relaxed text-[#e8e2d6] mb-10 max-w-xl">
              Get exclusive offers, product previews and hair care tips straight to your phone.
              Our community is where Ybera lovers connect and glow together.
            </p>

            <a
              href={WHATSAPP_GROUP}
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp"
              data-testid="whatsapp-group-join-btn"
            >
              <MessageCircle size={18} />
              Join the group
            </a>

            <div className="flex items-center gap-4 mt-7" data-testid="whatsapp-social-proof">
              <div className="flex -space-x-3">
                {groupClients.map((src, idx) => (
                  <img
                    key={idx}
                    src={src}
                    alt="Ybera client"
                    loading="lazy"
                    className="w-11 h-11 rounded-full object-cover border-2 border-[#1a1a1a] ring-1 ring-[#C9A961]/40"
                  />
                ))}
              </div>
              <div>
                <p className="font-serif-y text-2xl text-[#C9A961] leading-none" data-testid="whatsapp-member-count">
                  {GROUP_MEMBERS} <span className="text-[#FBF8F4]">active members</span>
                </p>
                <p className="font-sans-y text-[12px] text-[#b5b0a4] mt-1">
                  already in our community
                </p>
              </div>
            </div>

            <p className="font-sans-y text-[11px] tracking-[0.2em] uppercase text-[#8a8578] mt-5">
              Free • No spam • Leave anytime
            </p>
          </div>

          <div className="grid gap-4">
            {perks.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  className="flex items-start gap-5 p-6 bg-[#0f0f0f] border border-[#2a2a2a] hover:border-[#C9A961]/60 transition-colors"
                >
                  <div className="shrink-0 w-12 h-12 bg-[#C9A961]/15 flex items-center justify-center text-[#C9A961]">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h4 className="font-serif-y text-xl text-[#FBF8F4] mb-1">{p.title}</h4>
                    <p className="font-sans-y text-[13px] text-[#b5b0a4]">{p.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
